import { createFileRoute } from "@tanstack/react-router";
import { TemplateEditor } from "@/features/admin-email-templates/TemplateEditor";
function Page() { const { session } = Route.useRouteContext(); const { key } = Route.useParams(); return <TemplateEditor key={`${session.user.id}:${key}`} actorId={session.user.id} templateKey={key} />; }
export const Route = createFileRoute("/_authenticated/_protected/_admin/admin/email-templates/$key")({ component: Page });
